// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/weather-services.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/weather-services/weather-services.js';

mount([g0]);
